var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEnabledAlways = function SvgEnabledAlways(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    stroke: "#95C842",
    strokeWidth: 2,
    d: "M20,38c-9.9,0-18-8.1-18-18S10.1,2,20,2s18,8.1,18,18 M29,13.5L17.8,26.3 L11,19.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2,
    d: "M37.6,38.2H26.4v-9.4h11.2V38.2z M35.6,28.8v-3.6c0-1.9-1.5-3.4-3.4-3.4h-0.5c-1.9,0-3.4,1.5-3.4,3.4v3.6  M32,36.3v-2.4 M32,31.9c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1s1-0.4,1-1C33,32.4,32.6,31.9,32,31.9z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEnabledAlways);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/enabled_always.ffc960feb89ad437e3601247923b7fca.svg";